import { portalApi, TAGS } from "api/rtkApi";
import { pessimisticUpdate } from "utils/pessimisticUpdate";

import type { UUID } from "utils/uuid";

import type { SettlementPreferences } from "../models/SettlementPreferences";

type GetSettlementPreferencesResponse = SettlementPreferences;

type GetSettlementPreferencesRequest = {
  customerId?: UUID;
};

export type UpdateSettlementPreferencesResponse = SettlementPreferences;

export type UpdateSettlementPreferencesRequest = {
  customerId: UUID;
  settlementPreferences: SettlementPreferences;
};

const extendedApi = portalApi.injectEndpoints({
  endpoints: (builder) => ({
    getSettlementPreferences: builder.query<
      GetSettlementPreferencesResponse,
      GetSettlementPreferencesRequest
    >({
      query: ({ customerId }) =>
        `customers/${customerId}/countries/BR/settlement-preferences`,
      providesTags: (result, error, { customerId }) => [
        { type: TAGS.SETTLEMENT_PREFERENCES, customerId },
      ],
    }),
    updateSettlementPreferences: builder.mutation<
      UpdateSettlementPreferencesResponse,
      UpdateSettlementPreferencesRequest
    >({
      query: ({ customerId, settlementPreferences }) => ({
        url: `customers/${customerId}/countries/BR/settlement-preferences`,
        method: "PUT",
        body: settlementPreferences,
      }),
      async onQueryStarted(
        { customerId, settlementPreferences },
        { dispatch, queryFulfilled }
      ) {
        return pessimisticUpdate(queryFulfilled)(() => {
          dispatch(
            extendedApi.util.updateQueryData(
              "getSettlementPreferences",
              { customerId },
              (draft: SettlementPreferences) => {
                Object.assign(draft, settlementPreferences);
              }
            )
          );
        });
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetSettlementPreferencesQuery,
  useUpdateSettlementPreferencesMutation,
} = extendedApi;
